import withAemIntegration from "../../../../withAemIntegration";

const ComponentEditConfig = {
  emptyLabel: "Missing Account Info",
  isEmpty: function (props) {
    return !props || !props.title || props.title.trim().length < 1;
  },
};

const MissingAccount = (props) => {
  return <div></div>;
};

export default withAemIntegration(
  "lexus/components/drivers/forms/missing-account"
)(MissingAccount, ComponentEditConfig);
